import { render, staticRenderFns } from "./ARTransactionTable.vue?vue&type=template&id=52d36f08&scoped=true&"
import script from "./ARTransactionTable.vue?vue&type=script&lang=js&"
export * from "./ARTransactionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d36f08",
  null
  
)

export default component.exports